export default __webpack_public_path__ + "static/media/multishippingOptions.100533b8.svg";